export const JobState = {
    CREATED: "created",
    RETRY: "retry",
    ACTIVE: "active",
    COMPLETED: "completed",
    EXPIRED: "expired",
    CANCELLED: "cancelled",
    FAILED: "failed",
};
export const JOB_STATE_COLORS = {
    created: "#2196F3",
    retry: "#FF9800",
    active: "#4CAF50",
    completed: "#9E9E9E",
    failed: "#F44336",
    cancelled: "#FFC107",
    expired: "#9C27B0",
};
export const JOB_STATE_LABELS = {
    created: "Created",
    retry: "Retry",
    active: "Active",
    completed: "Completed",
    failed: "Failed",
    cancelled: "Cancelled",
    expired: "Expired",
};
